import { defineComponent as _defineComponent } from 'vue'
import {
  ref,
  computed,
  watch,
  watchEffect,
  onMounted,
  onUnmounted,
} from 'vue';
import TuiInput from '../Input';

interface Props {
  modelValue: Date;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DatepickerPC',
  props: {
    modelValue: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue: Date;
};



const showPicker = ref(false);
const selectedDate = ref(props.modelValue || new Date());
const currentYear = ref(selectedDate.value?.getFullYear());
const currentMonth = ref(selectedDate.value?.getMonth() + 1);

const pickerRef = ref<any>(null);
const closeOnOutsideClick = (event: any) => {
  if (!pickerRef.value.contains(event.target)) {
    showPicker.value = false;
  }
};
const togglePicker = () => {
  showPicker.value = !showPicker.value;
};
onMounted(() => {
  window.addEventListener('click', closeOnOutsideClick);
});

onUnmounted(() => {
  window.removeEventListener('click', closeOnOutsideClick);
});

watch(
  selectedDate,
  newValue => {
    emit('input', newValue);
  },
  { immediate: true }
);

watch(
  () => props.modelValue,
  newValue => {
    if (!newValue) return;
    selectedDate.value = newValue;
    currentMonth.value = selectedDate.value.getMonth() + 1;
    currentYear.value = selectedDate.value.getFullYear();
  },
  { immediate: true }
);

const changeMonth = (value: any) => {
  currentMonth.value += value;
  if (currentMonth.value === 0) {
    currentMonth.value = 12;
    currentYear.value -= 1;
  } else if (currentMonth.value === 13) {
    currentMonth.value = 1;
    currentYear.value += 1;
  }
};

const selectDate = (date: any) => {
  if (isPast(date)) {
    return;
  }
  selectedDate.value = date;
  showPicker.value = false;
};

const days = ref<any[]>([]);

const updateDays = () => {
  const daysArray = [];
  const firstDay = new Date(
    currentYear.value,
    currentMonth.value - 1,
    1
  ).getDay();
  const daysInMonth = new Date(
    currentYear.value,
    currentMonth.value,
    0
  ).getDate();
  const daysInPrevMonth = new Date(
    currentYear.value,
    currentMonth.value - 1,
    0
  ).getDate();

  for (let i = daysInPrevMonth - firstDay + 1; i <= daysInPrevMonth; i++) {
    const date = new Date(currentYear.value, currentMonth.value - 2, i);
    daysArray.push({
      id: date.toISOString(),
      label: i,
      date,
      otherMonth: true,
    });
  }

  for (let i = 1; i <= daysInMonth; i++) {
    const date = new Date(currentYear.value, currentMonth.value - 1, i);
    daysArray.push({
      id: date.toISOString(),
      label: i,
      date,
      otherMonth: false,
    });
  }

  const remainingDays = 35 - daysArray.length;
  if (remainingDays > 0) {
    for (let i = 1; i <= remainingDays; i++) {
      const date = new Date(currentYear.value, currentMonth.value, i);
      daysArray.push({
        id: date.toISOString(),
        label: i,
        date,
        otherMonth: true,
      });
    }
  }

  days.value = daysArray.slice(0, 35);
};

watchEffect(() => {
  updateDays();
});

const formattedDate = computed(
  () =>
    `${selectedDate.value.getFullYear()}-${selectedDate.value.getMonth() + 1}-${selectedDate.value.getDate()}`
);

const isSelected = (date: any) =>
  date.toISOString() === selectedDate.value.toISOString();

const isToday = (date: any) => {
  const today = new Date();
  return (
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate()
  );
};

const isPast = (date: any) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
};

const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

return { __sfc: true,props, emit, showPicker, selectedDate, currentYear, currentMonth, pickerRef, closeOnOutsideClick, togglePicker, changeMonth, selectDate, days, updateDays, formattedDate, isSelected, isToday, isPast, weekdays, TuiInput }
}

})